import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import InvoicesTable from "@/components/invoices/invoices-table";

const invoicesSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  numericRanges: z.string().optional(),
  status: z.string().optional(),
  /** Filtro por etiqueta (slug). */
  tag: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/invoices/")({
  validateSearch: invoicesSearchSchema,
  component: InvoicesPage,
});

function InvoicesPage() {
  const searchParams = Route.useSearch();

  return (
    <div className="space-y-4">
      <InvoicesTable
        currentPage={searchParams.page}
        basePath="/invoices"
        searchParams={searchParams}
      />
    </div>
  );
}
